import {combineReducers, configureStore} from '@reduxjs/toolkit'
import comicNews from "./features/comicNews";
import homepage from './features/homepage'
import stories from './features/stories'
import comments from "./features/comments";

const reducer = combineReducers({
  comicNews,
  comments,
  homepage,
  stories,
});

export default configureStore({
  reducer
});
